import { EventPreview } from '@/types/projects.types';
import { Post } from '../helpers';

const SetupProjectPreview = (eventUuid: string, channel: number): Promise<EventPreview> => {
  return Post({
    path: `/v3/admin/event/${eventUuid}/preview/${channel}`,
    body: { channel },
  });
};

export default SetupProjectPreview;
